import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgGridInterfaceStackLine = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M5.19727 2.25C3.56906 2.25 2.25 3.56906 2.25 5.19727V7.80273C2.25 9.43094 3.56906 10.75 5.19727 10.75H18.8027C20.4309 10.75 21.75 9.43094 21.75 7.80273V5.19727C21.75 3.56906 20.4309 2.25 18.8027 2.25H5.19727ZM5.19727 3.75H18.8027C19.6025 3.75 20.25 4.39748 20.25 5.19727V7.80273C20.25 8.60252 19.6025 9.25 18.8027 9.25H5.19727C4.39748 9.25 3.75 8.60252 3.75 7.80273V5.19727C3.75 4.39748 4.39748 3.75 5.19727 3.75ZM5.19727 13.25C3.56906 13.25 2.25 14.5691 2.25 16.1973V18.8027C2.25 20.4309 3.56906 21.75 5.19727 21.75H18.8027C20.4309 21.75 21.75 20.4309 21.75 18.8027V16.1973C21.75 14.5691 20.4309 13.25 18.8027 13.25H5.19727ZM5.19727 14.75H18.8027C19.6025 14.75 20.25 15.3975 20.25 16.1973V18.8027C20.25 19.6025 19.6025 20.25 18.8027 20.25H5.19727C4.39748 20.25 3.75 19.6025 3.75 18.8027V16.1973C3.75 15.3975 4.39748 14.75 5.19727 14.75Z",
		fill: "currentColor"
	})
});
export default SvgGridInterfaceStackLine;
